import { render, staticRenderFns } from "./addAuthorModal.vue?vue&type=template&id=ed5bf02a&scoped=true"
import script from "./addAuthorModal.vue?vue&type=script&lang=js"
export * from "./addAuthorModal.vue?vue&type=script&lang=js"
import style0 from "./addAuthorModal.vue?vue&type=style&index=0&id=ed5bf02a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5bf02a",
  null
  
)

export default component.exports